import React, { useEffect } from "react";
import "./AboutFounder.css";
import founderImg from "../assets/founder.png";

const AboutFounder = () => {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    revealElements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <section className="about-founder-section">
      <div className="about-founder-container reveal">
        {/* Left Side - Content */}
        <div className="about-founder-content">
          <h2 className="title-animate">Who We Are</h2>

          <p className="text-animate delay-1">
            Founded in 2019, <b>Recla</b> has been on a mission to make printing smarter, simpler, and more affordable. What started as a small vision has grown into a global presence across the <b>UAE, Bhutan, Bangladesh, Vietnam, USA, UK, and India, </b>trusted by businesses that count on us for quality, savings, and reliability.

          </p>

          <p className="text-animate delay-2">
            <b>Recla is a subsidiary of Rcube Recycling Pvt. Ltd.</b>, aligning advanced printing solutions with a broader focus on sustainability and responsible resource management.
          </p>
          <p>Today, we are proud to extend our expertise to <b>Nigeria</b>, continuing our journey of delivering world-class printing solutions.</p>

          <ul className="list-animate delay-3">
            <li>Cut costs without compromising on quality</li>
            <li>Provide 24×7 after-sales service you can rely on</li>
            <li>Simplify sourcing and importing of products</li>
            <li>Deliver global standards tailored to local needs</li>
          </ul>

          <p className="highlight-text delay-4">
            With every cartridge, every service call, and every partnership, our
            focus remains the same: <b>to be the printing solutions partner you can
              always count on.</b>
          </p>
        </div>

        {/* Right Side - Image */}
        <div className="about-founder-image">
          <div className="img-box">
            <img src={founderImg} alt="Founder of Recla" />
            <div className="img-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFounder;
